import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImageSizemeasurementService {
  CountInPX;

  constructor() {}

  /**
   * This functuion is used to get the Image Measurement
   * @param container -container data value
   * @returns measurement data value
   */
  getImageMeasurement(container) {
    let data = container.split('px');
    let updatedXPosition = data[0] <= 0 ? 0 : data[0];
    return updatedXPosition * 10.41666666666667;
  }

  /**
   * This function is used to getUpdatedImage Y POS
   * @param container -container data value
   * @returns data value
   */
  getUpdatedImageYPos(container) {
    let data = container.split('px');
    let updatedXPosition = data[0] <= 0 ? 0 : data[0];
    return updatedXPosition * 10.41666666666667;
  }

  /**
   * This function is used to get the getImageMeasurementOfFooter data value
   * @param container -container data value
   * @returns -Footer measurement Value
   */
  getImageMeasurementOfFooter(container) {
    let data = container.split('px');
    let updatedXPosition = data[0] <= 0 ? 0 : data[0];
    return updatedXPosition * 10.41666666666667;
  }

  /**
   * This function is used to get the UpdatedImageYPosOfFooter data
   * @param container -data value
   * @returns data value
   */
  getUpdatedImageYPosOfFooter(container) {
    let data = container.split('px');
    let updatedXPosition = data[0] <= 0 ? 0 : data[0];
    return 8000 + updatedXPosition * 10.41666666666667;
  }

  /*
     Using The below code we have set default X And Y position to the image.
    */
  setDefaultXPositionHeaderImage(defaultValue) {
    let defaultXPosition = defaultValue <= 0 ? 0 : defaultValue;
    return defaultXPosition / 10.41666666666667;
  }

  /**
   * This function is used to get the setDefaultYPositionHeaderImage data
   * @param defaultValue
   * @returns
   */
  setDefaultYPositionHeaderImage(defaultValue) {
    let defaultXPosition = defaultValue <= 0 ? 0 : defaultValue;
    return defaultXPosition / 10.41666666666667;
  }

  /**
   * This function is used to get the setDefaultWidthToHeaderImage data
   * @param defaultValue
   * @returns
   */
  setDefaultWidthToHeaderImage(defaultValue) {
    let defaultXPosition = defaultValue <= 0 ? 0 : defaultValue;
    return defaultXPosition / 10.4;
  }

  /**
   * This function is used to get the setDefaultHeightToHeaderImage data
   * @param defaultValue
   * @returns
   */
  setDefaultHeightToHeaderImage(defaultValue) {
    let defaultXPosition = defaultValue <= 0 ? 0 : defaultValue;
    return defaultXPosition / 10.42;
  }

  /**
   * This function is used to get the setDefaultXPositionFooterImage data
   * @param defaultValue
   * @returns
   */
  setDefaultXPositionFooterImage(defaultValue) {
    let defaultXPosition = defaultValue <= 0 ? 0 : defaultValue;
    return defaultXPosition / 10.41666666666667;
  }

  /**
   * This function is used to get the setDefaultYPositionFooterImage data
   * @param defaultValue
   * @returns
   */
  setDefaultYPositionFooterImage(defaultValue) {
    let defaultXPosition = defaultValue <= 0 ? 0 : defaultValue;
    return defaultXPosition / 10.41666666666667;
  }

  /**
   * This function is used to get the setDefaultWidthToFooterImage data
   * @param defaultValue
   * @returns
   */
  setDefaultWidthToFooterImage(defaultValue) {
    let defaultXPosition = defaultValue <= 0 ? 0 : defaultValue;
    return defaultXPosition / 10.4;
  }

  /**
   * This function is used to get the setDefaultHeightToFooterImage data
   * @param defaultValue
   * @returns
   */
  setDefaultHeightToFooterImage(defaultValue) {
    let defaultXPosition = defaultValue <= 0 ? 0 : defaultValue;
    return defaultXPosition / 10.42;
  }
}
